<template>
  <div>
    <div>
      <b-table hover small caption-top fixed responsive boardered show-empty
               id="reportTable"
               :fields="fields"
               :items="files"
               :busy="isLoading"
               :bordered="bordered"
               selectable
               sort-icon-left
               :select-mode="selectMode"
               @row-selected="onRowSelected"
               style="padding: 10px"
      >
        <template v-slot:cell(select)="{ rowSelected }">
          <b-icon-check-square v-if="rowSelected" aria-hidden="true" ></b-icon-check-square>
          <b-icon-square v-if="!rowSelected" aria-hidden="true"></b-icon-square>
        </template>
        <template v-slot:cell(actions)="row" style="min-height: 20em">
          <b-button variant="primary" size="sm" :href="row.item.url" target="_attach">download</b-button>
          <b-button variant="danger" size="sm" @click="showDeleteModal(row.item)">delete</b-button>
        </template>
        <div slot="table-busy" class="text-center text-danger my-2">
          <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
          <strong>Loading, Please Wait...</strong>
        </div>
        <template v-slot:empty="scope">
          <p>No files found.</p>
        </template>
      </b-table>
      <br>
    </div>
    <div>
      <b-modal id="delete-modal" title="Delete File" ok-variant="danger" ok-title="Confirm" @ok="deleteObject(selectedFile)">
        <form ref="form" @submit.prevent="deleteObject(selectedFile)">
          <p>You are about to <span class="text-danger">delete</span> file: {{ selectedFile.filename }}.</p>
          <p class="mt-2">Press Confirm to delete or Cancel to return to the report page.</p>
        </form>
      </b-modal>
    </div>
  </div>
</template>

<script>

import axios from "axios";

export default { //todo: error checking for status report
  data: () => ({
    selectMode: 'single',
    bordered: true,
    isLoading: false,
    selected: [],
    selectedFile: [],
    files: [],
    fields: [{key: 'select', label: 'Selected'},
      {key: 'filename', label: 'File Name'},
      {key: 'lastModified', label: 'Last Modified'},
      {key: 'formattedFileSize', label: 'File Size'},
      {key: 'actions', label: 'Actions'},
    ],
    orgType: 0
  }),

  mounted() {
    this.$watch('this.$store.state.selectedFacility', function() {
      this.fetchFiles()
    })
    this.loadEmployer()
  },

  computed: {
    selectedFacility() {
      this.fetchFiles()
      return this.$store.state.selectedFacility
    }
  },

  watch: {
    selectedFacility() {
      this.fetchFiles()
    }
  },

  methods: {
    onRowSelected(items) {
      this.selected = items
    },
    showDeleteModal(item) {
      this.selectedFile = item
      this.$bvModal.show('delete-modal')
    },
    closeDeleteModal() {
      this.$bvModal.hide('delete-modal')
    },
    deleteObject(item) {
      this.showDeleteModal(item)
      let payload = {
        bucketName: this.selectedFile.bucketName,
        objectName: item.name
      }
      axios.post(`${process.env.VUE_APP_API_BASE_URL}/bucket/delete`, payload)
        .then((response) => {
          if (response.status === 200) {
            this.closeDeleteModal()
            this.fetchFiles()
          }
        }).catch((error) => {
          console.log(error)
        })
    },

    fetchFiles() {
      this.isLoading = true
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/user/results/${this.$store.state.selectedFacility.id}/${this.orgType}`)
        .then((response) => {
          if (response.status === 200) {
            this.files = response.data.files
          }
          this.isLoading = false
        })
        .catch((err) => {
          console.log(err)
        })
      this.isLoading = false
    },

    loadEmployer() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/user`).then(response => {
        if (response.status === 200) {
          if (response.data.org.intendedUse === 'Certified child care center') {
            this.orgType = 1
          }
        }
      })
    }
  }
}

</script>

<style scoped>
.btn-sm, .btn-group-sm > .btn {
  margin-right: 5px;

}
</style>
